import styled from 'styled-components';

export const InpuTypeString = styled.input`
  background-color: transparent;
  border: 1px solid;
  border-color: #ccc;
  box-sizing: border-box;
  padding: 10px 20px;
  color: inherit;
  cursor: inherit;
  font-size: 14px;
  min-width: 0;
  width: 100%;
  line-height: 1.4285714285714286;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const FilterTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const FilterTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  min-width: fit-content;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    color: #e74c3c;
    background-color: #f8f9fa;
  }

  svg {
    font-size: 16px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ConditionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DropdownContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 180px;
  max-width: 300px;
`;

export const DropdownButton = styled.button<{ isOpen: boolean }>`
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 150px;

  &:hover {
    border-color: #57069e;
  }

  &:focus {
    outline: none;
    border-color: #57069e;
    box-shadow: 0 0 0 2px rgba(87, 6, 158, 0.1);
  }

  svg {
    font-size: 16px;
    color: #666;
  }
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
`;

export const DropdownItem = styled.div<{ isSelected?: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  background-color: ${(props) => (props.isSelected ? '#f0f0f0' : 'white')};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  /* Container do Macro deve ocupar todo o espaço disponível */
  > div[style*='flex: 1'] {
    flex: 1;
    width: 100%;
    min-width: 0; /* Permite que o flex funcione corretamente */

    /* Garantir que o Select do Macro ocupe todo o espaço */
    .single-select {
      width: 100% !important;
    }

    .react-select__control {
      width: 100% !important;
      min-width: 0 !important;
    }
  }
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    font-weight: 500;
  }
`;

export const StyledInput = styled(InpuTypeString)`
  flex: 1;
  width: 100%;
  min-width: 0;
`;

export const FullWidthButton = styled.div`
  width: 100%;

  button {
    width: 100% !important;
  }
`;
